import { Directive, ElementRef, AfterViewInit } from '@angular/core';

@Directive({
  selector: '[appNumericInputMode]'
})
export class NumericInputModeDirective implements AfterViewInit {
  constructor(private el: ElementRef<HTMLInputElement>) {}

  ngAfterViewInit() {
    const inputs = this.el.nativeElement.querySelectorAll('input');
    inputs.forEach(input => {
      input.setAttribute('inputmode', 'numeric');
      input.setAttribute('pattern', '[0-9]*');
    });
  }
}
